import script from "./CandidatesBrowserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidatesBrowserModal.vue?vue&type=script&setup=true&lang=js"

import "./CandidatesBrowserModal.vue?vue&type=style&index=0&id=7944ad60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7944ad60"]])

export default __exports__